import React, { useState, useEffect } from 'react';
import { useBreakpointValue } from '@chakra-ui/react';

const EditableTextBox = ({ words, boxWidth, onChange, border }) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const [isEditing, setIsEditing] = useState(false);
  const [text, setText] = useState(words);

  const handleDoubleClick = () => {
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };

  const handleChange = event => {
    setText(event.target.value);
    onChange(event.target.value);
  };

  useEffect(() => {
    setText(words);
  }, [words]);

  return (
    <div
      onDoubleClick={handleDoubleClick}
      onTouchEnd={handleDoubleClick}
      style={{
        display: 'inline-block',
        border: border ?? '2px solid black',
        borderRadius: '8px',
        padding: '5px',
        minWidth: '100px',
        height: '40px',
        width: boxWidth,
        cursor: isEditing ? 'text' : 'pointer',
      }}
    >
      {isEditing ? (
        <input
          type="text"
          value={text}
          onChange={handleChange}
          onBlur={handleBlur}
          autoFocus
          placeholder=""
          style={{
            border: 'none',
            outline: 'none',
            width: '100%',
            fontSize: '16px',
          }}
        />
      ) : (
        <span
          style={{
            color: text ? 'black' : 'gray',
            fontSize: '16px',
            height: '40px',
          }}
        >
          {text ? text : isMobile ? 'Tap to edit' : 'Double click me to edit'}
        </span>
      )}
    </div>
  );
};

export default EditableTextBox;
